import { Card } from 'components/Card';
import { ICONS } from 'components/Icon';
import { useSelector } from 'hooks/useSelector';
import { theme } from 'lib/theme';
import React from 'react';
import { Platform } from 'react-native';
import { selectAseSetupLibraryFolder } from 'store/remote/selectors';

type Props = {
  id: number;
};

export const FolderListItem: React.FC<Props> = React.memo(({ id }) => {
  const folder = useSelector((state) =>
    selectAseSetupLibraryFolder(state, id),
  )!;

  return (
    <Card
      label={folder.name}
      labelIcon={ICONS.FolderOpenLight}
      margin={false}
      style={{
        backgroundColor:
          Platform.OS === 'web'
            ? theme.colors.background
            : theme.colors.background80,
      }}
      labelStyle={{ marginTop: theme.paddingHorizontalHalf }}
    />
  );
});
